// extracted by mini-css-extract-plugin
module.exports = {"header":"ErrorBoundary_header__1YsCr","backLink":"ErrorBoundary_backLink__BbwXH"};